import XLRLogger from 'src/common/helpers/logger';
import { store } from '../../common/redux/configure-store';
import { AlertActions } from '../../common/redux/reducers/alert-reducer';
import { alertLookup } from './service/alert-lookup';

const PeripheralDevice = 'PeripheralDevice';
const POSManualAlerts = 'POSManualAlerts';

export const getAlertTemplate = async (alertGroupId?: string): Promise<void> => {
  alertGroupId = alertGroupId ? alertGroupId : POSManualAlerts;
  const alertsStatus = alertGroupId === POSManualAlerts ? 'Active' : undefined;
  return alertLookup(alertGroupId, alertsStatus)
    .then((alertData): void => {
      store.dispatch(AlertActions.updateAlerts(alertData, alertGroupId ?? ''));
    })
    .catch((err): void => {
      if (err.code === 'AlertGroupNotFound') {
        XLRLogger.error({
          message: `Alert group ${alertGroupId} not found`,
          source: 'get-alert-template.ts',
        });
        return;
      }
      throw err;
    });
};

export const getCashierAlertTemplate = async (): Promise<void> => {
  return getAlertTemplate();
};

export const getPeripheralAlterTemplate = async (): Promise<void> => {
  return getAlertTemplate(PeripheralDevice);
};
